/*
* @Description: 成长值配置
* @Author: ma.cq
* @Date: 2018-10-18 10:47:56
* @LastEditors: ma.cq
* @LastEditTime: 2018-10-18 10:47:56
*/
<template>
  <!--:class="item.initialGrowthValue==='0' || !item.initialGrowthValue ? 'isError form-input' : 'form-input'"-->
  <div class="grow-config">
    <el-row :inline="true" label-width="150px">
      <el-col :span="3">回炼、涮罐、置换管线、调拨:</el-col>
      <el-col :span="21">
        <div>
          <el-form class="fromFix" :inline="true" :model="form" :rules="rules" ref="form">
            <el-form-item prop="initialGrowthValue">
              <el-input @input="(val)=>initialFixChange(val)" class="form-input" maxlength="5" placeholder="初始值" v-model="form.initialGrowthValue"></el-input>
            </el-form-item>
            <span class="inlineBlockSpan">+</span>
            <el-form-item prop="growthRate">
              <el-input @input="(val)=>growthFixChange(val)" class="form-input" maxlength="5" placeholder="增速" v-model="form.growthRate"></el-input>
            </el-form-item>
            <el-form-item prop="timeType">
              <el-select class="form-select"
                         @change="(val)=>selectFixChange(val)"
                         v-model="form.timeType"
                         placeholder="请选择">
                <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div></el-col>
      <el-col :span="8"><div class="grid-content bg-purple"></div></el-col>
    </el-row>
    <div v-if="growData.arr2.length > 0">
      <el-row v-for="(list,index) in growData.arr2" :inline="true" :key="index" label-width="150px">
        <el-col :span="3">
          {{'客户等级（'+list[0].memberLevelName+'）'}}
        </el-col>
        <el-col :span="21">
          <div v-for="(item,i) in list" :key="i">
            <el-form :model="item" :rules="rules" :ref="'ruleForm'+index+i" :inline="true">
              <span class="inlineBlockSpan">{{`${item.lineType === 1 ? '线上:' : '线下:'}`}}</span>
              <el-form-item prop="initialGrowthValue">
                <el-input @input="(val)=>initialChange(val,index, i)" maxlength="5"
                          v-model="item.initialGrowthValue"
                          :placeholder="`${item.lineType === 1 ? '线上' : '线下'}初始值`"></el-input>
              </el-form-item>
              <span class="inlineBlockSpan">+</span>
              <el-form-item prop="growthRate">
                <el-input @input="(val)=>growthChange(val,index, i)" maxlength="5"
                          class="form-input"
                          v-model="item.growthRate"
                          :placeholder="`${item.lineType === 1 ? '线上' : '线下'}增速`"></el-input>
              </el-form-item>
              <span class="inlineBlockSpan">乘以司机信誉值%</span>
              <el-form-item prop="timeType">
                <el-select class="form-select" v-model="item.timeType"
                           @change="(val)=>selectChange(val,index,i)"
                           placeholder="请选择">
                  <el-option
                    v-for="item in options1"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :offset="3">
          <el-button type="primary" @click="handleSubmit" class="btn">保 存</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="no-grow-config" v-else>
      无客户等级可供等待值配置，请先进行客户等级配置 !
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { normalizeNumber } from '../../../common/verify'

export default {
  name: 'growConfig',
  data () {
    return {
      form: {
        initialGrowthValue: 100,
        growthRate: 100,
        timeType: 1
      },
      options1: [
        {
          value: 1,
          label: '分/5分钟'
        }, {
          value: 2,
          label: '分/10分钟'
        }, {
          value: 3,
          label: '分/15分钟'
        }, {
          value: 4,
          label: '分/20分钟'
        }, {
          value: 5,
          label: '分/25分钟'
        }, {
          value: 6,
          label: '分/30分钟'
        }
      ],
      rules: {
        initialGrowthValue: [
          { required: true, message: '请输入初始值', trigger: ['change', 'blur'] },
          { pattern: /^[1-9]\d*$/, message: '格式有误，请重新输入' }
        ],
        growthRate: [
          { required: true, message: '请输入增速', trigger: ['change', 'blur'] }
        ],
        timeType: [
          { required: true, message: '请选择', trigger: ['change', 'blur'] }
        ]
      }
    }
  },
  methods: {
    ...mapActions(['getGrowData', 'saveGrowConfig']),
    handleSubmit () {
      let arr = []
      const fixValue = {
        ...this.form,
        memberLevelID: 0,
        lineType: 1
      }
      arr.push(fixValue)
      this.growData.arr2.map((list, i) => {
        list.map((item, index) => {
          arr.push(item)
        })
      })
      // arr.map((list, i) => {
      //   this.$refs[`ruleForm${i}`].validate((valid) => {
      //     console.log(valid)
      //   })
      // })
      let bol = true
      arr.map(list => {
        if (!list.initialGrowthValue || !list.growthRate || !list.timeType) {
          bol = false
        }
      })
      if (bol) {
        this.saveGrowConfig({ growthValueListVO: arr }).then(res => {
          if (res.success) {
            this.$message.success('保存成功！')
          }
        })
      }
    },
    // 客户等级
    initialChange (val, index, i) {
      this.$nextTick(() => {
        this.growData.arr2[index][i].initialGrowthValue = normalizeNumber(val)
      })
    },
    selectChange (val, index, i) {
      this.$nextTick(() => {
        this.growData.arr2[index][i].timeType = val
      })
    },
    growthChange (val, index, i) {
      this.$nextTick(() => {
        this.growData.arr2[index][i].growthRate = normalizeNumber(val)
      })
    },
    // 回炼、涮罐、置换管线、调拨
    initialFixChange (val) {
      this.$nextTick(() => {
        this.growData.arrFix[0].initialGrowthValue = normalizeNumber(val)
      })
    },
    selectFixChange (val) {
      this.$nextTick(() => {
        this.growData.arrFix[0].timeType = val
      })
    },
    growthFixChange (val) {
      this.$nextTick(() => {
        this.growData.arrFix[0].growthRate = normalizeNumber(val)
      })
    }
  },
  mounted () {
    this.getGrowData()
  },
  computed: {
    ...mapGetters({
      growData: 'growConfigGetter'
    })
  },
  watch: {
    growData: {
      deep: true,
      handler: function (newVal) {
        // 赋初始值
        if (newVal) {
          this.form = this.growData.arrFix[0]
          this.$nextTick(() => {
            this.$refs['form'].clearValidate()
          })
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .fromFix {
    margin-left: 47px;
  }
  .form-input {
    width: 200px;
  }

  .form-select {
    margin-left: 10px;
  }

  .btn {
    /*margin-left: 100px;*/
  }
  .inlineBlockSpan{
    display: inline-block;
    height: 32px;
    line-height: 32px;
    margin: 0 15px 0 5px;
  }
  .grow-config{
    .no-grow-config{
      text-align: center;
      font-size: 16px;
    }
  }
</style>
<style lang="scss">
  .isError {
    input {
      border-color: #f56c6c;
    }

    .el-input__inner {
      border-color: #f56c6c;
    }
  }
</style>
